import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ResponsiveColumnComponent } from './components/columns/responsive-column/responsive-column.component';
import { ResponsiveDataColumnComponent } from './components/columns/responsive-data-column/responsive-data-column.component';
import {
  ResponsiveHeaderColumnComponent,
} from './components/columns/responsive-header-column/responsive-header-column.component';
import { ResponsiveHeaderRowComponent } from './components/rows/responsive-header-row/responsive-header-row.component';
import { ResponsiveRowComponent } from './components/rows/responsive-row/responsive-row.component';
import { CardElementDirective } from './directives/card-element.directive';
import { ListDataDirective } from './directives/list-data.directive';
import { ListElementDirective } from './directives/list-element.directive';
import { ListHeaderDirective } from './directives/list-header.directive';
import { ResponsiveHeaderColumnDirective } from './directives/responsive-header-column.directive';
import { ResponsiveMobileDataColumnDirective } from './directives/responsive-mobile-data-column.directive';
import { ResponsiveTableComponent } from './responsive-table.component';

@NgModule({
  declarations: [
    ResponsiveTableComponent,
    ResponsiveHeaderRowComponent,
    ResponsiveHeaderColumnComponent,
    ResponsiveRowComponent,
    ResponsiveColumnComponent,
    ResponsiveDataColumnComponent,
    ResponsiveHeaderColumnDirective,
    ResponsiveMobileDataColumnDirective,
    ListHeaderDirective,
    ListDataDirective,
    ListElementDirective,
    CardElementDirective
  ],
  imports: [CommonModule],
  exports: [
    ResponsiveTableComponent,
    ResponsiveHeaderRowComponent,
    ResponsiveHeaderColumnComponent,
    ResponsiveRowComponent,
    ResponsiveColumnComponent,
    ResponsiveHeaderColumnDirective,
    ResponsiveMobileDataColumnDirective,
    ListHeaderDirective,
    ListDataDirective
  ]
})
export class ResponsiveTableModule {}
